export enum InventoryCountStepEnum {
    InventoryHeader,
    InventoryCount,
    InventoryCountDetail
}